var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.letters, function (letter, ind) {
      return _c(
        "v-popover",
        {
          key: ind,
          staticClass: "d-inline",
          attrs: { placement: "bottom", "auto-hide": true },
        },
        [
          _c("i", {
            class: {
              "icon-fa icon-fa-envelope": true,
              green: letter.sended,
              red: !letter.sended,
            },
          }),
          _vm._v(" "),
          _c("template", { slot: "popover" }, [
            _c("div", { staticClass: "letters_info" }, [
              _c("p", [_vm._v(_vm._s(_vm.getLetterType(letter)))]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(letter.created_at)),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.getLetterMessage(letter)))]),
            ]),
          ]),
        ],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }